import { useTrendingHashtags } from '@/hooks/useTrendingHashtags';
import { TrendingUp } from 'lucide-react';

/**
 * Horizontal scroll row of Ditto trending-hashtag chips. Used in the Feed's
 * Discover tab header and the Search app's Hashtags tab. Renders nothing while
 * loading or when Ditto returns no trends, so it degrades quietly.
 */
export function TrendingTags({
  onSelect,
  className = '',
  limit = 12,
}: {
  onSelect: (tag: string) => void;
  className?: string;
  limit?: number;
}) {
  const { data: tags } = useTrendingHashtags(limit);

  if (!tags || tags.length === 0) return null;

  return (
    <div className={`flex items-center gap-1.5 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${className}`}>
      <TrendingUp className="w-3 h-3 text-muted-foreground shrink-0" />
      {tags.map(({ tag, uses }) => (
        <button
          key={tag}
          onClick={() => onSelect(tag)}
          className="shrink-0 px-2 py-0.5 rounded-full bg-muted/60 hover:bg-muted text-[11px] font-medium transition-colors"
          title={`${uses.toLocaleString()} uses`}
        >
          #{tag}
        </button>
      ))}
    </div>
  );
}
